import { Helmet, HelmetProvider } from 'react-helmet-async';
import OutgoingTenantsAdministration from "shared/components/rental/sections/outgoing-tenants-administration";

const OutgoingTenants = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Uitgaande Huurders | Yally</title>
        </Helmet>
      </HelmetProvider>

      <OutgoingTenantsAdministration />
    </>
  );
};

export default OutgoingTenants;
